module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 30
// module chunks = 0